import React, { useState, useEffect } from "react"
import Airtable from "airtable"
import { Link } from "@reach/router"
import "../styles/App.scss"
import kila_profile from "../static/kila_profile.png"
//Components
import Header from "../components/Header.jsx"
import Footer from "../components/Footer.jsx"
import BarChart from "../components/Histogram.jsx"
import LineChart from "../components/LineChart.jsx"
import ChartOne from "../components/ChartOne.jsx"
//Utils
import tableNumbers from "../utils/tableNumbers"

const ProfileImg = props => {
  return (
    <div className="profile-container">
      {props.data.image !== undefined ? (
        <img
          className="profile-img"
          src={`${props.data.image}`}
          alt="profile-img"
        />
      ) : (
        <img className="profile-img" src={kila_profile} />
      )}
    </div>
  )
}

const ProfileBox = props => {
  return (
    <div className="box">
      <div className="category-1">
        <p className="category-mobile">
          Supervisor: <span>{props.data.supervisor}</span>
        </p>
        <p>
          Estatus de Avance:{" "}
          <span>{Math.floor(props.data.progress_status * 100)}%</span>
        </p>
      </div>
      <div className="category-2">
        {/* <p>
          Supervisor en seguridad e higiene:{" "}
          <span>{props.data.security_hygienic_supervisor}</span>
        </p> */}
        {/* <p>
          Avance Fínanciero: <span>{props.data.financial_progress}%</span>
        </p> */}
      </div>
      <div className="category-3">
        <p>
          FOLIO: <span>{props.data.folio}</span>
        </p>
        <p>
          Indice de Cumplimiento: <span>{props.weekIndex}%</span>
        </p>
      </div>
      <div className="category-4">
        <p>
          Estatus de la obra: <span>{props.data.project_status}</span>
        </p>
      </div>
    </div>
  )
}

const Profile = props => {
  // Inicialización de estados
  const [profile, setProfile] = useState({})
  // Almacena las gráficas en order creciente
  const [chart, setChart] = useState([])
  // Aquí se almacenan los datos de la segunda gráfica
  const [data, setData] = useState([])
  //Ell arreglo que se lee proviene desde utils
  const [weeks, setWeeks] = useState(tableNumbers)
  // Indice iterable para acceder a cada arreglo de chart[]
  const [index, setIndex] = useState(0)
  //Estado para almacenar la Semana índicada
  const [selected, setSelected] = useState(26)
  //Estados para control y acceso a semanas extra
  const [chartTwo, setChartTwo] = useState([])
  //Estado para el histograma
  const [hist, setHist] = useState([])
  //Estado para insertar el indice de cump. general en la dona
  const [weekIndex, setWeekIndex] = useState(0)

  const getProfileData = () => {
    let base = new Airtable({ apiKey: "keyRICOfYlRaLgFzw" }).base(
      "appLpc9Ewre2aXiiz"
    )

    base("Obras General")
      .select({
        filterByFormula: `{No.} = ${props.page.toString()}`,
        maxRecords: 1,
        view: "Grid view",
      })
      .eachPage(
        function page(records, fetchNextPage) {
          // This function (`page`) will get called for each page of records.

          records.forEach(function (record) {
            setProfile({
              folio: record.get("FOLIO"),
              building_name: record.get("OBRA"),
              contratist_name: record.get("CONTRATISTA"),
              image: record.get("PORTADA")[0].url,
              supervisor: record.get("SUPERVISOR"),
              progress_status: record.get("ESTATUS AV."),
              project_status: record.get("ESTATUS OBRA"),
            })
          })

          fetchNextPage()
        },
        function done(err) {
          if (err) {
            console.error(err)
            return
          }
        }
      )
  }

  //Función para realizar un API request a los valores del histograma
  const histRequest = (week, data) => {
    let base = new Airtable({ apiKey: "keyRICOfYlRaLgFzw" }).base(
      "appLpc9Ewre2aXiiz"
    )

    base(`Semana ${week + 1}`)
      .select({
        filterByFormula: `{OBRA} = "${props.project}"`,
        maxRecords: 1,
        view: "Grid view",
      })
      .eachPage(
        function page(records, fetchNextPage) {
          let store = []
          records.forEach(function (record) {
            store.push(record.get("Registro personal del IMSS") * 100)
            store.push(record.get("Verificación Médica (incluido COVID)") * 100)
            store.push(record.get("Equipo de protección personal") * 100)
            store.push(record.get("Certificados D3 en actividades") * 100)
            store.push(
              record.get("Calidad en la maquinaria y herramienta") * 100
            )
            store.push(record.get("Uso adecuado") * 100)
            store.push(record.get("Mantenimiento") * 100)
            store.push(record.get("Limpieza y orden") * 100)
            store.push(record.get("Señaletica") * 100)
            store.push(record.get("Procesos constructivos") * 100)
          })

          data.push(store)

          fetchNextPage()
        },
        function done(err) {
          if (err) {
            console.error(err)
            return
          }
        }
      )
  }

  // Función para realizar un API request a los valores de la gráfica de dona
  const chartRequest = () => {
    let base = new Airtable({ apiKey: "keyRICOfYlRaLgFzw" }).base(
      "appLpc9Ewre2aXiiz"
    )

    //Hay que filtrar basado en el nombre de la columna OBRA
    // -> filterByFormula: `{OBRA} = ${props.project}`,
    base(`Semana ${selected}`)
      .select({
        filterByFormula: `{OBRA} = "${props.project}"`,
        maxRecords: 1,
        view: "Grid view",
      })
      .eachPage(
        function page(records, fetchNextPage) {
          // This function (`page`) will get called for each page of records.
          let store = []
          records.forEach(function (record) {
            store.push(record.get("Registro personal del IMSS") * 100)
            store.push(record.get("Verificación Médica (incluido COVID)") * 100)
            store.push(record.get("Equipo de protección personal") * 100)
            store.push(record.get("Certificados D3 en actividades") * 100)
            store.push(
              record.get("Calidad en la maquinaria y herramienta") * 100
            )
            store.push(record.get("Uso adecuado") * 100)
            store.push(record.get("Mantenimiento") * 100)
            store.push(record.get("Limpieza y orden") * 100)
            store.push(record.get("Señaletica") * 100)
            store.push(record.get("Procesos constructivos") * 100)

            setWeekIndex(record.get("ÍNDICE DE CUMPLIMIENTO") * 100)

            setChart(store)
            setValue([
              {
                data: store,
                // backgroundColor: [
                //   "#036666",
                //   "#14746f",
                //   "#248277",
                //   "#358f80",
                //   "#469d89",
                //   "#56ab91",
                //   "#67b99a",
                //   "#78c6a3",
                //   "#88d4ab",
                //   "#99e2b4",
                // ],
                backgroundColor: [
                  "#1d4e89",
                  "#1c558e",
                  "#1a5b92",
                  "#16679a",
                  "#0f80aa",
                  "#0899ba",
                  "#04a6c2",
                  "#00b2ca",
                  "#20bac5",
                  "#3fc1c0",
                ],
                borderWidth: 1,
              },
            ])
          })

          fetchNextPage()
        },
        function done(err) {
          if (err) {
            console.error(err)
            return
          }
        }
      )
  }

  // Función para hacer API request a los valores de la gráfica de puntos y lineas
  const chartRequestTwo = () => {
    let base = new Airtable({ apiKey: "keyRICOfYlRaLgFzw" }).base(
      "appLpc9Ewre2aXiiz"
    )

    base("Promedio Mensual")
      .select({
        filterByFormula: `{OBRA} = "${props.project}"`,
        // 1 obra por el número de registros total:
        maxRecords: 1,
        view: "Grid view",
      })
      .eachPage(
        function page(records, fetchNextPage) {
          // This function (`page`) will get called for each page of records.

          let months = [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre",
          ]
          let store = []

          records.forEach(function (record) {
            //Almacena todos los valores por meses aunque los no existentes sean del tipo NaN
            months.map(elem => {
              store.push(
                Math.round(record.get(`${elem.toUpperCase()} 2021`) * 100)
              )
            })

            setData(store)
          })

          fetchNextPage()
        },
        function done(err) {
          if (err) {
            console.error(err)
            return
          }
        }
      )
  }

  // Estados que controlan los input de los dropdown
  const [weekOne, setWeekOne] = useState("")
  const [weekTwo, setWeekTwo] = useState("")
  const [value, setValue] = useState([])
  //Rango de semanas para intervalos del histograma
  const [range, setRange] = useState("")

  //Controlador del segundo dropdown para añadir semana
  const handleDropdown = event => {
    setWeekTwo(event.target.value)

    let base = new Airtable({ apiKey: "keyRICOfYlRaLgFzw" }).base(
      "appLpc9Ewre2aXiiz"
    )

    base(`Semana ${event.target.value}`)
      .select({
        filterByFormula: `{OBRA} = "${props.project}"`,
        // 1 obra por el número de registros total:
        maxRecords: 1,
        view: "Grid view",
      })
      .eachPage(
        function page(records, fetchNextPage) {
          // This function (`page`) will get called for each page of records.
          let store = []

          records.forEach(function (record) {
            store.push(record.get("Registro personal del IMSS") * 100)
            store.push(record.get("Verificación Médica (incluido COVID)") * 100)
            store.push(record.get("Equipo de protección personal") * 100)
            store.push(record.get("Certificados D3 en actividades") * 100)
            store.push(
              record.get("Calidad en la maquinaria y herramienta") * 100
            )
            store.push(record.get("Uso adecuado") * 100)
            store.push(record.get("Mantenimiento") * 100)
            store.push(record.get("Limpieza y orden") * 100)
            store.push(record.get("Señaletica") * 100)
            store.push(record.get("Procesos constructivos") * 100)

            setChartTwo(store)
            setWeekIndex(Math.floor(record.get("ÍNDICE DE CUMPLIMIENTO") * 100))
          })

          setChart(store)
          setValue([
            {
              data: store,
              // backgroundColor: [
              //   "#036666",
              //   "#14746f",
              //   "#248277",
              //   "#358f80",
              //   "#469d89",
              //   "#56ab91",
              //   "#67b99a",
              //   "#78c6a3",
              //   "#88d4ab",
              //   "#99e2b4",
              // ],
              backgroundColor: [
                "#1d4e89",
                "#1c558e",
                "#1a5b92",
                "#16679a",
                "#0f80aa",
                "#0899ba",
                "#04a6c2",
                "#00b2ca",
                "#20bac5",
                "#3fc1c0",
              ],
              borderWidth: 3,
            },
          ])

          fetchNextPage()
        },
        function done(err) {
          if (err) {
            console.error(err)
            return
          }
        }
      )
  }

  // Método para comunicar a sidenav un cambio en el dropdown
  const handleChange = event => {
    setWeekOne(event.target.value)
    setSelected(() => event.target.value)
    setRange(event.target.value)
  }

  // API Request para obtener como un objecto la información de cada perfil
  useEffect(() => {
    getProfileData()
  }, [])

  // API request para la obtención de los datos para el histograma
  const histCall = async () => {
    let data = []
    for (let i = 25; i < 112; i++) {
      histRequest(i, data)
    }
    setHist(data)
  }

  useEffect(() => {
    histCall()
  }, [])

  // Side effect que se ejecuta al cambiar el estado de la semana
  useEffect(() => {
    chartRequest()
    chartRequestTwo()
  }, [selected, setSelected])

  return (
    <div>
      {/* Header se comunica con su componente hijo Sidenav*/}
      <Header
        page={props.page}
        data={chart}
        index={index}
        handleChange={handleChange}
        handleDropdown={handleDropdown}
        value={value}
        weekOne={weekOne}
        weekTwo={weekTwo}
        // getWeeks={getWeeks}
        weeks={weeks}
      />
      {/* Inicio del perfil | Datos Iniciales */}
      <h1 className="building-title">{profile.building_name}</h1>
      <h1 className="contratista">Contratista: {profile.contratist_name}</h1>
      <ProfileImg data={profile} />
      <ProfileBox data={profile} compliance={data} weekIndex={weekIndex} />
      <div className="buttons">
        <Link className="home" to="/kila-home-id-980615">
          &larr; Regresar
        </Link>
        <Link className="note" to="compliance-notes">
          Notas de Cumplimiento
        </Link>
        <Link className="note" to="incompliance-notes">
          Notas de Incumplimiento
        </Link>
      </div>
      <div className="charts-box">
        <div className="charts-box-1">
          <div className="bars-chart-box">
            <h4 className="chart-title-2">
              Indicadores Generales por Semana (%)
            </h4>
            <BarChart value={hist} range={range} />
          </div>
        </div>
        <div className="charts-box-2">
          <div className="line-chart-box">
            <h4 className="chart-title-2">
              Indice de Cumplimiento General por Mes (%)
            </h4>
            <LineChart value={data} />
          </div>
          <div className="doughnut-chart-box">
            <h4 className="chart-title-2">Indicadores Semana Actual (%)</h4>
            <ChartOne
              index={index}
              draw={chart}
              value={value}
              weekIndex={weekIndex}
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Profile
